import {
  allAllowedToChoosePassportDocumentTypeCodes,
  allowedToChooseAddressRegDocumentTypeCodes,
} from '@/components/Forms/constants';

import { SERVICE_CODES } from '@/lib/consts';

import { DocumentTypeCode } from '@/api/types';

export const SERVICE_CODE = SERVICE_CODES.COLD_STEEL_TRANSPORTATION;
export const STEP_NUMBER_TO_PAY = 9;
export const STEP_NUMBER_SIGN_UP = 8;

export const disallowedDocumentTypeCodesForAdditionalDocumentStep = [
  ...allAllowedToChoosePassportDocumentTypeCodes,
  ...allowedToChooseAddressRegDocumentTypeCodes,
  DocumentTypeCode.CONTRACT_SECURITY_ACTIVITIES,
  DocumentTypeCode.PAYMENT_REFERENCE,
];
